import React from "react";
import vtLogo from "../Assets/Images/vt-purple-logo.png";
const TermsAndConditions = () => {
  return (
    <>
      <div className="container">
        <img
          className="img-fluid mt-4 mb-1"
          src={vtLogo}
          style={{ margin: "auto", display: "block", width: "180px" }}
          alt="Vidyuttech logo"
        />

        <h5 style={{ color: "#7225F5" }} className="text-center mb-4">
          Vidyut Green Labs
        </h5>
        <section>
          <div className="row my-5">
            <br />
            <br />
            <h2>TERMS OF SERVICE</h2>
            <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
              Vidyut Green Labs., a company incorporated under the provisions of
              the Companies Act, 2013 and having its registered office at 2
              <sup>nd</sup> Floor, 2<sup>nd</sup> Building, Hustlehub Techpark,
              27th Main Road End, HSR Layout Sector 1, Bangalore - 560102,
              Karnataka, India (hereinafter referred to as “<b>Company</b>” or “
              <b>we</b>” or “<b>us</b>”), is the owner of the progressive
              webpage titled ‘VidyutTech’ and a mobile application named
              “Vidyut” (collectively referred as “<b>Platform”</b>).
              <br />
              <br />
              The Company requests the User (as defined below) to carefully go
              through these terms & conditions (“<b>Terms of Service</b>” or “
              <b>TOS</b>” or “<b>Terms</b>”) prior to accessing the Platform or
              availing Services (as defined below) using the Platform. If User
              continues to browse and use the Platform to avail Services, User
              irrevocably and unconditionally is agreeing to comply with, abide
              by and be bound by all these obligations as stipulated in this
              TOS, which together read with our privacy policy available at{" "}
              <a href="https://www.vidyutgreenlabs.com/privacy-policy/">
                https://www.vidyutgreenlabs.com/privacy-policy/
              </a>{" "}
              and any other applicable policies referred to herein or made
              available on the Platform (collectively referred as “
              <b>Terms and Conditions</b>”). The Terms and Conditions shall
              govern the Company’s relationship with User in relation to the
              usage of the Platform. These Terms and Conditions supersede all
              previous oral, written terms and conditions (if any) communicated
              to User and shall act as a binding agreement between Company and
              the User.
              <br />
              <br />
              This TOS is in compliance with the Information Technology Act,
              2000 and applicable amendments, rules, regulations and guidelines
              enacted thereunder from time to time (“IT Act”) with specific
              mention rule 3(1) of Information Technology (Intermediary
              Guidelines and Digital Media Ethics Code) Rules, 2021
              (“Intermediary Rules”). TOS is an electronic record generated by a
              computer system and does not require any physical, electronic, or
              digital signature
              <br />
              <br />
              <b>
                IF YOU DO NOT AGREE TO BE BOUND BY ALL TERMS AND CONDITIONS
                CAPTURED IN THE TOS, PLEASE DO NOT USE THE PLATFORM OR SERVICES.
              </b>
            </p>
            <ul style={{ listStyleType: "none" }}>
              <li>
                <h3>1. Definitions</h3>
                <br />
                <ul
                  style={{
                    textAlign: "justify",
                    wordBreak: "keep-all",
                    listStyleType: "none",
                  }}
                >
                  <li>
                    “<b>Company</b>,” “<b>we</b>,” “<b>us</b>,” or “<b>our</b>”
                    means Vidyut Green Labs and any other companies that are its
                    subsidiaries and affiliates.
                  </li>
                  <br />
                  <li>
                    “<b>Service(s)</b>” means services provided through the
                    Platform, as described in further detail under clause 3
                    below. The Services provided through the Platform may change
                    from time to time, at the sole discretion of the Company.
                  </li>
                  <br />
                  <li>
                    “<b>User</b>” or “<b>you</b>” shall mean any person or
                    entity who shall avail Services on the Platform, or his/her
                    representatives or affiliates who are registered on the
                    Platform.
                  </li>
                </ul>
              </li>
              <br />
              <li>
                <h3>2. Updation of Terms and Conditions</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  Your use of the Platform is subject to the Terms and
                  Conditions, which may be updated, amended, modified or revised
                  by us from time to time with/without notice to you. To ensure
                  that you are aware of any additions, revisions, amendments or
                  modifications that we may have made to these Terms and
                  Conditions, it is important for you to refer to the Terms and
                  Conditions from time to time. The updated Terms and Conditions
                  shall be effective immediately and shall supersede these. We
                  shall not be under an obligation to notify you of any changes
                  to the Terms and Conditions. You shall be solely responsible
                  for reviewing the Terms and Conditions from time to time for
                  any modifications. If you continue to use the
                  Platform/Services after the Updated Terms and Conditions have
                  been published, it shall be deemed that you have read and
                  understood and accept the Updated Terms and Conditions. Any
                  reference to Terms of Service, TOS, made herein shall refer to
                  the latest version of the Terms of Service.
                </p>
              </li>
              <br />
              <li>
                <h3>3. Service(s) provided to Users</h3>
                <p>
                  Kindly note that the list provided on the Platform is
                  exhaustive. The Company through its Vidyut app provides the
                  following services to the Users:
                </p>{" "}
                <ul style={{ listStyle: "inside" }}>
                  <li>
                    Recharging of the your wallet, tracking recharge history,
                    checking odometer readings, viewing EV status and kilometres
                    driven.{" "}
                  </li>
                  <li>
                    Viewing EMI details, making EMI payments directly through
                    the app, and tracking payment history.
                  </li>
                  <li>Accessing all your vehicle information in one place.</li>
                  <li>
                    Receiving reminders for upcoming EMIs and get alerts for low
                    wallet balances.
                  </li>
                  <li>
                    Accessing customer support for any issues with just a single
                    click; and
                  </li>
                  <li>Paying for the battery.</li>
                </ul>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  The Company is offering the Platform for the usage of the
                  User(s) who are residing in India and Company expects that the
                  Services shall be availed only by the User (s) residing in
                  India. Company disclaims all the responsibilities/liabilities
                  arising out of or in relation to any claim arising out of or
                  in relation to the (a) usage of the Platform outside the
                  territory of India; (b) availing Services from outside the
                  territory of India. In the event if User breaches the
                  aforesaid condition, User hereby agrees to defend, indemnify
                  and hold Company, its directors, employees, successors,
                  assigns harmless from any claims arising out of or in relation
                  to the breach of the said condition in relation to the usage
                  of the Platform.
                  <br />
                  <br />
                  <b>
                    Company, may upon prior intimation or without prior
                    intimation, and reserves the right to modify the Services
                    provided to Users. In the event of such
                    modifications/amendments to the Services, the same shall be
                    published on the Platform.
                  </b>
                </p>
              </li>
              <br />
              <li>
                <h3>4. Eligibility</h3>
                <br />
                <ol>
                  <li
                    style={{
                      listStyle: "decimal",
                      textAlign: "justify",
                      wordBreak: "keep-all",
                    }}
                  >
                    By using Platform, you affirm that you are at least 18 years
                    of age and are fully able and competent to enter into the
                    terms, conditions, obligations, affirmations,
                    representations, warranties set forth in the Terms and
                    Conditions, and to abide by and comply with the terms stated
                    therein. Registration of User in the Platform is available
                    only to persons who can form legally binding contracts.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <h3>5. User Account Registration</h3>
                <br />
                <ol style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  <li style={{ listStyle: "decimal" }}>
                    User who is at least 18 years of age may create a valid
                    account and avail the Services. In order to use the
                    Platform, you have to create an account (“<b>Account</b>”).
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    You can create Account by signing up on the Platform using
                    your phone number/email ID, and entering your current city
                    and state you are residing in.
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    Alternatively, registration may be done by downloading the
                    App from Google PlayStore and/or Apple AppStore. The User is
                    required to install the "Vidyut" app on their device to
                    register and conduct transactions using the Services.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <h3>6. Platform License</h3>
                <br />
                <ol style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  <li style={{ listStyle: "decimal" }}>
                    Subject to your compliance with the TOS, Company grants you
                    a limited, non-exclusive, non-transferable license: (i) to
                    view, download and print any content of Platform solely for
                    your personal and non-commercial purposes; and (ii) to
                    access, modify, edit and download any content, to which you
                    are permitted access solely for your personal and non-
                    commercial purposes. You have no right to sublicense the
                    license rights granted herein.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    You will not use, copy, adapt, modify, prepare derivative
                    works based upon, distribute, license, sell, transfer,
                    publicly display, publicly perform, transmit, stream,
                    broadcast or otherwise exploit the Platform and Services,
                    except as expressly permitted in the TOS. No licenses or
                    rights are granted to you by implication or otherwise under
                    any intellectual property rights owned or controlled by
                    Platform or its licensors, except for the licenses and
                    rights expressly granted in the TOS.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <h3>7. Additional Conditions for Loanees</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  If you are a User who is a Loanee and has applied for a loan
                  under the Platform, you agree that in addition to these Terms,
                  you will also be bound by the additional terms and conditions
                  shared by the Company applicable to individuals who apply for
                  loans from the Company. You also hereby expressly consent to
                  the Company and any entity engaged by the Company to provide
                  the Services having access to your financial data such as your
                  credit score and other information that is required in order
                  to determine your loan eligibility.
                </p>
              </li>
              <br />
              <li>
                <h3>8. Fees</h3>
                <br />
                <ol style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  <li style={{ listStyle: "decimal" }}>
                    The access to the Platform is free of cost and the Company
                    is not charging any fees for usage of Platform.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    Each Party shall comply with applicable tax laws, be liable
                    to fulfill its tax obligations and incur tax, charges, cost
                    and fees as applicable.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <h3>
                  9. Use of Your Information and Content and other content
                  displayed on the Platform
                </h3>
                <br />
                <ol style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  <li style={{ listStyle: "decimal" }}>
                    If you create, transmit, submit, display or otherwise make
                    available any information while using the Services, you may
                    provide only information that you own or have the right to
                    use. We may only use the information you provide as
                    permitted by our Privacy Policy and applicable law. For
                    example, we will never share your personally identifiable
                    information without your prior permission. Please closely
                    review our Privacy Policy for more information regarding how
                    we use and disclose your personal information. Our Privacy
                    Policy is hereby incorporated into these Terms of Use by
                    this reference.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    We reserve the right to maintain, delete or destroy all
                    information and materials posted or uploaded through the
                    Services pursuant to our internal record retention and/or
                    destruction policies. We (may/may not) make use of
                    third-party cloud services providers or use our own service
                    infrastructure for hosting the servers and databases. While
                    we make commercially reasonable efforts to ensure that the
                    data stored on our servers is persistent and always
                    available to the User, we will not be responsible in the
                    event of failure of the third-party servers or any other
                    factors outside our reasonable control that may cause the
                    User’s data to be permanently deleted, irretrievable, or
                    temporarily inaccessible.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    You acknowledge and agree that we may preserve your
                    information and may also disclose your related information
                    if required to do so by law; or in the good faith belief
                    that such preservation or disclosure is reasonably necessary
                    to: (a) comply with legal process, applicable laws or
                    government requests; (b) enforce these TOS; (c) respond to
                    claims that any of your usage of the Platform violates the
                    rights of third parties; (d) detect, prevent, or otherwise
                    address fraud, security or technical issues; or (e) protect
                    the rights, property, or personal safety of the Platform,
                    its users, or the public.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    You agree to only provide such information that does not
                    violate the law or any person’s rights (including
                    intellectual property rights).
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <h3>10. Third Party Services</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  The Company shall provide Users to connect with third party
                  service providers. The Company is not responsible for, and
                  does not endorse, any third-party services mentioned on the
                  Platform. It is hereby stated that Company shall in no way be
                  responsible for any acts or omissions of third parties. Any
                  transaction, dealings or communication otherwise that the User
                  may have with such third parties are at the User’s own risk
                  and we make no warranties, express or implied regarding the
                  quality or suitability of the services or products of such
                  third- party vendors.
                </p>
              </li>
              <br />
              <li>
                <h3>11. Rules and Conduct</h3>
                <br />
                <ol style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  <li style={{ listStyle: "decimal" }}>
                    As a condition of use, you promise not to use the Services
                    for any purpose that is prohibited by the TOS; or other
                    rules or policies implemented by us from time to time; or in
                    violation of any applicable laws.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    By way of example, and not as a limitation, you shall not
                    (and shall not permit any third party to) take any action
                    that: (i) would constitute a violation of any applicable
                    law, rule or regulation; (ii) infringes on any intellectual
                    property or other right of any other person or entity; (iii)
                    is threatening, abusive, harassing, defamatory, libelous,
                    deceptive, fraudulent, invasive of another’s privacy,
                    tortuous, obscene, offensive, or profane; or (iv)
                    impersonates any person or entity. The Company reserves the
                    right to disable any Account from the Platform at any time
                    for any reason (including, but not limited to, upon receipt
                    of claims or allegations from third parties or authorities;
                    or if Company is concerned that You may have violated the
                    Terms of Use), or for no reason at all with or without
                    notice to the User/Users.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    Additionally, you shall not share any information that: (i)
                    may be harmful to minors or children below the age of 18
                    (eighteen) years; (ii) threatens the unity, integrity,
                    defence, security or sovereignty of the country, friendly
                    relations with foreign states or public order or causes
                    incitement to the commission of any cognisable offence or
                    prevents investigation of any offence or is insulting any
                    other nation; and (iii) is invasive of another’s privacy,
                    hateful, or racially, ethnically objectionable, disparaging,
                    relating or encouraging money laundering or gambling, or
                    otherwise unlawful in any manner whatever; (iv) harms minors
                    in any manner; (v) infringes any patent, trademark,
                    copyright or other proprietary rights; (vi) violates any
                    laws for time being; and (vii) impersonate any person.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    Furthermore, you shall not (directly or indirectly): (i)
                    take any action that imposes or may impose an unreasonable
                    or disproportionately large load on Company’s (or its third
                    party providers’) infrastructure; (ii) interfere or attempt
                    to interfere with the proper working of the Platform or any
                    activities conducted on the Platform; (iii) bypass any
                    measures we may use to prevent or restrict access to the
                    Platform (or parts thereof); (iv) decipher, decompile,
                    disassemble, reverse engineer or otherwise attempt to derive
                    any source code or underlying ideas or algorithms of any
                    part of the Platform, except to the limited extent
                    applicable laws specifically prohibit such restriction; (v)
                    modify, translate, or otherwise create derivative works of
                    any part of the Platform; or (vi) copy, rent, lease,
                    distribute, or otherwise transfer any or all of the rights
                    that you receive hereunder.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <h3>12. Alerts Provided by The Company </h3>
                <br />
                <ol style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  <li style={{ listStyle: "decimal" }}>
                    The Company provides you with multiple automatic alerts
                    while providing Services.
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    You understand and agree that any alerts provided to you
                    through the Platform may be delayed or prevented by a
                    variety of factors. We will do our best to provide alerts in
                    a timely manner with accurate information. However, we
                    neither guarantee the delivery nor the accuracy of the
                    content of any alert. You also agree that we shall not be
                    liable for any delays, failure to deliver, or misdirected
                    delivery of any alert; for any errors in the content of an
                    alert; or for any actions taken or not taken by you or any
                    third party in reliance on an alert.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <h3>13. Contact You</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  You agree that we may contact you through telephone, email,
                  SMS, or any other means of communication for the purpose of:
                </p>
                <ol>
                  <li style={{ listStyle: "decimal" }}>
                    Obtaining feedback in relation to Platform/Services.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    Resolving any complaints, information, or queries by other
                    Users; and
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    You agree to provide your fullest co-operation further to
                    such communication by Company.
                    <br />
                    <br />
                  </li>
                </ol>
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  By submitting suggestions or other feedback regarding our
                  Services/Platform, you agree that we can use and share such
                  feedback for any purpose without any compensation to you and
                  we are under no obligation to such feedback confidential.
                </p>
              </li>
              <br />
              <li>
                <h3>14. Profile Ownership and Editing Rights</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  We ensure easy access to the Users by providing a tool to
                  update your profile information. We reserve the right to
                  moderate the changes or updates requested by you and we shall
                  take an independent decision whether to publish or reject the
                  requests submitted for the respective changes or updates in
                  your profile. You hereby represent and warrant that you are
                  fully entitled, under applicable law, to provide information
                  as part of your profile or otherwise while using our Services,
                  and that no such information breaches any third-party rights,
                  including intellectual property rights and applicable data
                  protection laws. Upon becoming aware of a breach of the
                  foregoing representation, we may modify or delete parts of
                  your profile information at our sole discretion with or
                  without notice to you.
                </p>
              </li>
              <br />
              <li>
                <h3>
                  15. Rights and Obligation relating to the usage of the
                  Platform
                </h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  Users shall be prohibited from carrying out the any illegal
                  acts in the Platform including but not limited to acts
                  mentioned below:
                </p>
                <ol>
                  <li style={{ listStyle: "decimal" }}>
                    violating or attempting to violate the integrity or security
                    of the Platform;
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    transmitting any information on or through the Platform that
                    is disruptive or competitive to the provision of our
                    Services;
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    intentionally submitting on the Platform any incomplete,
                    false or inaccurate information;
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    using any engine, software, tool, agent or other device or
                    mechanism (such as spiders, robots, avatars or intelligent
                    agents) to navigate or search the Platform;
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    circumventing or disabling any digital rights management,
                    usage rules, or other security features of the Platform.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    any unlawful activities in the Platform which are prohibited
                    by laws of India.
                    <br />
                    <br />
                  </li>
                </ol>
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  The Company shall, upon obtaining knowledge by itself or been
                  brought to actual knowledge by an affected person in writing
                  or through email signed with electronic signature about any
                  such information as mentioned above, be entitled to disable
                  such information that is in contravention of this Clause. We
                  shall also be entitled to preserve such information and
                  associated records as per applicable laws for production to
                  governmental authorities for investigation purposes.
                  <br />
                  <br />
                  In case of non-compliance with any applicable laws, rules or
                  regulations, or the Terms and Conditions (including the
                  Privacy Policy) by a User, we shall have the right to
                  immediately terminate your access or usage rights to the
                  Platform and Services and to remove non-compliant information
                  from the Platform.
                  <br />
                  <br />
                  We may disclose or transfer User-generated information to our
                  affiliates or governmental authorities in such manner as
                  permitted or required by applicable law, and you hereby
                  consent to such transfer. In accordance with the applicable
                  laws, we shall transfer sensitive personal data or information
                  including any information, to any other body corporate or a
                  person in India, or located in any other country, that ensures
                  the same level of data protection that is adhered to by us,
                  only if such transfer is necessary for the performance of the
                  lawful contract between Company or any person on its behalf
                  and the User or where the User has consented to data transfer.
                </p>
              </li>
              <br />
              <li>
                <h3>16. Company and User Materials</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  While rendering Services, Company directly or through its
                  representatives, may provide Users with certain materials
                  relevant to the Services, which may be in the form of audio,
                  video, written and oral content (“<b>Company Materials</b>
                  ”). Company Materials shall be the exclusive property of the
                  Company. User hereby agrees and acknowledges that he/she shall
                  ensure that the Company Materials are not shared with any
                  third party, without Company’s written consent and any breach
                  of such nature shall cause financial and irreparable injury to
                  Company. Company hereby provides User with a revocable,
                  non-exclusive, non-transferable, non-sublicensable, limited
                  license to use the Company Materials solely for its personal
                  purpose and not for any commercial use. While availing
                  Services, User may submit various materials to Company in the
                  form of audio/video/written content, (“<b>User Materials</b>
                  ”). User hereby provides Company with an exclusive,
                  transferrable, perpetual and irrevocable license to use the
                  User Materials for its use. User hereby agrees and
                  acknowledges that User Materials shall not infringe any
                  intellectual property rights of third party and shall be
                  responsible for any claims arising out of infringement.
                </p>
              </li>
              <br />
              <li>
                <h3>17. Modification</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  We reserve the right, at any time and in with sole discretion,
                  to change, modify, or amend the Platform (in whole, or in
                  part) or any of its Services (in whole, or in part), in
                  compliance with the applicable legal and regulatory framework.
                  You agree that We will not be liable to You for any change,
                  modification or amendment of the Platform or its Services, or
                  any part thereof.
                </p>
              </li>
              <br />
              <li>
                <h3>18. Support</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  The Company offers an email-based support system along with an
                  online knowledge pool of FAQs. In case you require any
                  assistance or support, you may access support resources or
                  contact our support by emailing at contactus@vidyuttech.com
                  and raise a ticket for your query.
                  <br />
                  <br />
                  The Company shall revert to every complaint within 24 hours of
                  receipt of the complaint. Further, the Company shall take best
                  possible efforts to redress the complaint within 15 days of
                  receipt of the complaint. Any suggestions by Company regarding
                  use of the Services shall not be construed as a warranty.
                  <br />
                  <br />
                  The User agrees and acknowledges that the Company shall
                  address and attempt to resolve the complaint received in
                  accordance with the standard policies and procedures adopted
                  by the Company, the User’s disapproval/discontent with the
                  outcome/mode of redressal shall not be deemed to mean
                  non-redressal of the complaint by the Company. Any suggestions
                  by Company regarding use of the Service shall not be construed
                  as a warranty.
                </p>
              </li>
              <br />
              <li>
                <h3>19. Termination</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  We may terminate your usage of the Platform at any time for
                  any reason, including breach of the Terms and Conditions. We
                  have the right (but not the obligation) to refuse to grant
                  access to Platform. Except for the rights and license granted
                  in these terms, we reserve all other rights and grant no other
                  rights or licenses, implied or otherwise.
                  <br />
                  <br />
                  Once temporarily suspended, indefinitely suspended or
                  terminated, the User may not continue to use the Platform
                  under the same account, a different account or re-register
                  under a new account. On termination of an account due to the
                  reasons mentioned herein, such User shall no longer have
                  access to data, messages and other material kept on the
                  Platform by such User. All provisions of the TOS, which by
                  their nature should survive termination, shall survive
                  termination, including, without limitation, warranty
                  disclaimers, indemnity and limitations of liability.
                </p>
              </li>
              <br />
              <li>
                <h3>20. Disclaimer</h3>
                <br />
                <ul
                  style={{
                    textAlign: "justify",
                    wordBreak: "keep-all",
                    listStyle: "inside",
                  }}
                >
                  <li>
                    THE SERVICES (INCLUDING, WITHOUT LIMITATION, ANY CONTENT) IS
                    PROVIDED “AS IS” AND “AS AVAILABLE” AND IS WITHOUT WARRANTY
                    OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED
                    TO, THE IMPLIED WARRANTIES OF TITLE, NON- INFRINGEMENT,
                    MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, AND
                    ANY WARRANTIES IMPLIED BY ANY COURSE OF PERFORMANCE OR USAGE
                    OF TRADE, ALL OF WHICH ARE EXPRESSLY DISCLAIMED.
                  </li>
                  <li>
                    THE COMPANY (INCLUDING) ITS DIRECTORS, EMPLOYEES, AGENTS,
                    SUPPLIERS, SPONSORS AND PARTNERS DO NOT WARRANT THAT: (A)
                    THE SERVICE WILL BE SECURE OR AVAILABLE AT ANY PARTICULAR
                    TIME OR LOCATION; (B) ANY DEFECTS OR ERRORS WILL BE
                    CORRECTED; (C) ANY CONTENT OR SOFTWARE AVAILABLE AT OR
                    THROUGH THE SERVICE IS FREE OF VIRUSES OR OTHER HARMFUL
                    COMPONENTS; OR (D) THE RESULTS OF USING THE SERVICE WILL
                    MEET YOUR REQUIREMENTS. YOUR USE OF THE SERVICE THROUGH THE
                    USE OF WEBSITE OR APP IS SOLELY AT YOUR OWN RISK. SOME
                    STATES DO NOT ALLOW LIMITATIONS ON HOW LONG AN IMPLIED
                    WARRANTY LASTS, SO THE ABOVE LIMITATIONS MAY NOT APPLY TO
                    YOU.
                  </li>
                  <li>
                    COMPANY IS NOT IN THE BUSINESS OF PROVIDING ANY FINANCIAL
                    ADVICE, NOR ANY BANKING OR NBFC RELATED SERVICES, NOR OTHER
                    PROFESSIONAL SERVICES OR ADVICE. THROUGH YOUR USE OF
                    COMPANY’S PLATFORM, YOU ACKNOWLEDGE AND AGREE THAT
                    INFORMATION PROVIDED BY COMPANY IS SIMPLY INFORMATIONAL
                    ONLY, AND SHOULD NOT BE CONSIDERED A SUBSTITUTE FOR THE
                    SERVICES OR ADVICE OF A COMPETENT PROFESSIONAL. FURTHER, THE
                    INFORMATION PROVIDED HEREIN SHOULD NOT BE TAKEN AS FINANCIAL
                    PLANNING OR INVESTMENT SOLICITATION. NO FIDUCIARY
                    RELATIONSHIP HAS BEEN CREATED BETWEEN YOU AND COMPANY.
                  </li>
                  <li>
                    YOU HEREBY UNDERSTAND AND ACKNOWLEDGE THAT THROUGH YOUR USE
                    OF COMPANY SERVICES, YOU ARE NOT BEING REPRESENTED BY AN
                    ATTORNEY, CERTIFIED FINANCIAL PLANNER, NOR OTHER REGULATED
                    ADVISOR. CERTAIN ASPECTS OF THE COMPANY SERVICES MAY PROVIDE
                    ACCESS TO SUCH A PROFESSIONAL (FOR EXAMPLE THROUGH A
                    REFERRAL SERVICE BY WHICH COMPANY RECEIVES AFFILIATION FEES)
                    OR PROVIDE TAX-RELATED INFORMATION, BUT IF YOU ARE IN NEED
                    OF FINANCIAL ADVICE, WE ADVISE YOU TO CONSULT THE
                    APPROPRIATE ADVISOR, SUCH AS YOUR OWN ATTORNEY, ACCOUNTANT,
                    OR OTHER PROFESSIONAL.
                  </li>
                  <li>
                    YOU UNDERSTAND AND AGREE THAT IF YOU USE, ACCESS, DOWNLOAD,
                    OR OTHERWISE OBTAIN INFORMATION, MATERIALS, OR DATA THROUGH
                    THE APP OR WEBSITE, THE SAME SHALL BE AT YOUR OWN DISCRETION
                    AND RISK AND THAT YOU WILL BE SOLELY RESPONSIBLE FOR ANY
                    DAMAGE TO YOUR PROPERTY (INCLUDING YOUR COMPUTER SYSTEM
                    AND/OR OTHER DEVICE) OR LOSS OF DATA THAT RESULTS FROM THE
                    DOWNLOAD OR USE OF SUCH MATERIAL OR DATA.
                  </li>
                </ul>
              </li>
              <br />
              <li>
                <h3>21. Indemnification</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  You shall defend, indemnify, and hold harmless the Company,
                  its affiliates/subsidiaries/joint venture partners and each of
                  its, and its affiliates’/subsidiaries/joint venture partners’
                  employees, contractors, directors, suppliers and
                  representatives from all liabilities, losses, claims, and
                  expenses, including reasonable attorneys’ fees, that arise
                  from or relate to (i) your use or misuse of, or access to, the
                  Services and Platform; or (ii) your violation of the Terms and
                  Conditions; or any applicable law, contract, policy,
                  regulation or other obligation. We reserve the right to assume
                  the exclusive defense and control of any matter otherwise
                  subject to indemnification by you, in which event you will
                  assist and cooperate with us in connection therewith.
                </p>
              </li>
              <br />
              <li>
                <h3>22. Limitation of Liability</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT SHALL
                  COMPANY (INCLUDING ITS DIRECTORS, EMPLOYEES, AGENTS, SPONSORS,
                  PARTNERS, SUPPLIERS, CONTENT PROVIDERS, LICENSORS OR
                  RESELLERS,) BE LIABLE UNDER CONTRACT, TORT, STRICT LIABILITY,
                  NEGLIGENCE OR ANY OTHER LEGAL OR EQUITABLE THEORY WITH RESPECT
                  TO THE SERVICES (I) FOR ANY LOST PROFITS, DATA LOSS, LOSS OF
                  GOODWILL OR OPPORTUNITY, OR SPECIAL, INDIRECT, INCIDENTAL,
                  PUNITIVE, OR CONSEQUENTIAL DAMAGES OF ANY KIND WHATSOEVER,
                  (II) FOR YOUR RELIANCE ON THE SERVICES (III) FOR ANY DIRECT
                  DAMAGES (IV) FOR ANY MATTER BEYOND ITS OR THEIR REASONABLE
                  CONTROL, EVEN IF COMPANY HAS BEEN ADVISED OF THE POSSIBILITY
                  OF ANY OF THE AFOREMENTIONED DAMAGES.
                </p>
              </li>
              <br />
              <li>
                <h3>23. Exemptions to liability of Company</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  You further agree and confirm that Company shall not be
                  responsible, in any manner whatsoever, for any
                  delay/unavailability of Services or failure to meet its
                  obligations under the Terms and Conditions, which may be
                  caused, directly or indirectly, due to:
                </p>
                <ol>
                  <li style={{ listStyle: "decimal" }}>
                    your failure to cooperate;
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    your unavailability and/or unresponsiveness;
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    your failure to provide accurate and complete information;
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    your failure to provide or facilitate the submission of User
                    Materials in timely manner;
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    any event beyond Company’s reasonable control.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <h3>24. Governing Law</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  These Terms and Conditions shall be governed by the laws of
                  India without regard to its conflict of law provisions. You
                  and Company agree to submit to the personal and exclusive
                  jurisdiction of the state and federal courts located at
                  Bangalore, India.
                </p>
              </li>
              <br />
              <li>
                <h3>25. Miscellaneous</h3>
                <br />
                <ol style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  <li style={{ listStyle: "decimal" }}>
                    Terms and Conditions are the entire agreement and
                    understanding between you and Company with respect to the
                    Services and usage of Platform.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    If any provision of the Terms and Conditions are found to be
                    unenforceable or invalid, that provision will be limited or
                    eliminated to the minimum extent necessary so that the Terms
                    and Conditions will otherwise remain in full force and
                    effect and enforceable.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    The failure of either party to exercise in any respect any
                    right provided for herein shall not be deemed a waiver of
                    any further rights hereunder.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    The Terms and Conditions are personal to you, and are not
                    assignable or transferable by you except with Company’s
                    prior written consent. Company may assign, transfer or
                    delegate any of its rights and obligations hereunder without
                    any consent.
                    <br />
                  </li>
                  <li style={{ listStyle: "decimal" }}>
                    No agency, partnership, joint venture, or employment
                    relationship is created as a result of the Terms and
                    Conditions and neither party has any authority of any kind
                    to bind the other in any respect. All notices under the
                    Terms and Conditions will be in writing and will be deemed
                    to have been duly given when received, if personally
                    delivered or sent by certified or registered mail, return
                    receipt requested; when receipt is electronically confirmed,
                    if transmitted by facsimile or e-mail; or two days after it
                    is sent, if sent for next day delivery by recognized
                    overnight delivery service.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <h3>26. Grievance Redressal Mechanism</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  In case the borrower has any grievance about any of the
                  aspects concerning the loan availed, he/she shall first bring
                  it to the notice of Mr. Gaurav Srivastava on
                  gro@vidyuttech.com .
                  <br />
                  <br />
                  Any discrepancies or grievances with regard to content and or
                  comment or breach of the Terms and Conditions shall be taken
                  up with the designated Grievance Officer as mentioned below
                  via in writing or through email signed with the electronic
                  signature to
                  <br />
                  <br />
                  <b>Attention</b>: Mr. Gaurav Srivastava
                  <br />
                  <b>Email ID</b>: gro@vidyuttech.com
                  <br />
                  <b>Phone Number</b>: 7027024496
                  <br />
                  <b>Address</b>: 2<sup>nd</sup> Floor, 2<sup>nd</sup> Building,
                  Hustlehub Techpark, 27th Main Road End, HSR Layout Sector 1,
                  Bangalore - 560102, Karnataka, India
                </p>
              </li>
              <br />

              <li>
                <h3>27. Contact</h3>
                <br />
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  If you have any questions regarding the Services or usage of
                  the Platform, please contact Company at{" "}
                  <a href="mailto:contactus@vidyuttech.com">
                    contactus@vidyuttech.com
                  </a>
                </p>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </>
  );
};

export default TermsAndConditions;
